<template>
  <main class="view just-blocks">
    <template v-for="(block, idx) in blocks" >
      <BlockParagraph
        v-if="block.type === 'Paragraph'"
        :key="`block-paragraph-${idx}`"
        :content="block.data"
        :odd="idx % 2 !== 0"
      />
      <BlockParagraphPic
        v-else-if="block.type === 'ParagraphPic'"
        :key="`block-paragraphpic-${idx}`"
        :content="block.data"
        :odd="idx % 2 !== 0"
      />
      <BlockTimeline
        v-else-if="block.type === 'Timeline'"
        :key="`block-timeline-${idx}`"
        :content="block.data"
      />
      <BlockHero
        v-else-if="block.type === 'Hero'"
        :key="`block-hero-${idx}`"
        :content="block.data"
      />
      <Youtube
        v-else-if="block.type === 'Youtube'"
        :key="`block-youtube-${idx}`"
        :content="block.data"
      />
      <Gallery
        class="blocked"
        v-else-if="block.type === 'Gallery'"
        :key="`block-gallery-${idx}`"
        :block-content="block.data"
      />
    </template>
  </main>
</template>

<script>
  import BlockParagraph from '@/components/ui/BlockParagraph';
  import BlockParagraphPic from '@/components/ui/BlockParagraphPic';
  import BlockTimeline from '@/components/ui/BlockTimeline';
  import BlockHero from '@/components/ui/BlockHero';
  import Youtube from '@/components/ui/Youtube';
  import Gallery from '@/components/ui/Gallery';

  export default {
    name: 'JustBlocks',
    components: {
      BlockHero,
      BlockTimeline,
      BlockParagraphPic,
      BlockParagraph,
      Youtube,
      Gallery,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      blocks() {
        return this.$b.data?.content?.blocks || [];
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.just-blocks {
  @include max-width-constraints;
  padding-top: 40px;
  width: 100%;

  @include screen-tablet {
    padding-top: 40px;
  }

  @include screen-mobile {
    padding-top: 40px;
  }
}
</style>
